<template>
  <div
    :class="$style['wrapper']"
    class="content-box-wrapper"
  >
    <div
      v-if="$slots['header']"
      ref="headerRef"
      :class="$style['header']"
      class="content-box-header"
    >
      <slot name="header"/>
    </div>
    <div
      v-if="!scrollable"
      :class="$style['content']"
    >
      <ds-loader
        :is-loading="isLoading"
        class="loader-wrapper"
      >
        <slot name="content" />
      </ds-loader>
    </div>
    <div v-else>
      <VuePerfectScrollbar
        :settings="settings"
        :style="{'max-height': scrollableHeight}"
        :class="{ 'scrollable-content': showScrollableShadow }"
      >
        <div class="content-scroll " >
          <slot name="content" />
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      v-if="$slots.footer"
      :class="$style['footer']"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "DsContentBox",
  components: {
    VuePerfectScrollbar
  },
  props: {
    scrollable: {
      type: Boolean,
      default: false
    },
    scrollableHeight: {
      type: String,
      default: ""
    },
    showScrollableShadow: {
      type: Boolean,
      default: false
    },
    scrollToBottom: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 50
      }
    };
  },
  mounted() {
    this.$emit("headerRefMounted", this.$refs.headerRef);
  }
};
</script>

<style lang="scss">
.content-box-wrapper {
  .ps__scrollbar-y-rail {
    right: 3px !important;
  }
  .content-scroll {
    padding: 14px 17px 13px 17px;
  }
}
.loader-wrapper {
  &--active {
    min-height: 75px;
  }
  .inner-gray-content {
    min-height: 75px;
  }
  .fetching-error-box {
    min-height: 75px;
  }
}
</style>

<style lang="scss" module>
@import "../../scss/_variables.scss";

$inner-padding: 14px 17px 13px 17px;

.wrapper {
  background-color: #fff;
  color: $black-blue-color;
  border-radius: 5px;
}
.header {
  padding: 19px 16px 13px 16px;
  border-bottom: 1px solid $light-border-color;
}
.content {
  padding: $inner-padding;
}
.footer {
  border-top: 1px solid $light-border-color;
  padding: 16px 24px 24px 40px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-content-box.vue